var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDsInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96875 13C2.96875 6.92487 7.89362 2 13.9688 2C20.0439 2 24.9688 6.92487 24.9688 13C24.9688 19.0751 20.0439 24 13.9688 24C7.89362 24 2.96875 19.0751 2.96875 13ZM13.9688 0C6.78905 0 0.96875 5.8203 0.96875 13C0.96875 20.1797 6.78905 26 13.9688 26C21.1485 26 26.9688 20.1797 26.9688 13C26.9688 5.8203 21.1485 0 13.9688 0ZM13.9688 7C13.4165 7 12.9688 7.44772 12.9688 8V8.01C12.9688 8.56229 13.4165 9.01 13.9688 9.01H13.9787C14.531 9.01 14.9787 8.56229 14.9787 8.01V8C14.9787 7.44772 14.531 7 13.9787 7H13.9688ZM15.4116 13.3518C15.826 11.6942 14.1052 10.3138 12.5769 11.0779L12.5215 11.1056C12.0276 11.3526 11.8273 11.9532 12.0743 12.4472C12.3213 12.9412 12.922 13.1414 13.416 12.8944C13.4377 12.8836 13.4622 12.9032 13.4563 12.9268L12.5259 16.6482C12.1115 18.3059 13.8323 19.6862 15.3606 18.9221L15.3607 18.9221L15.416 18.8944C15.91 18.6474 16.1102 18.0467 15.8632 17.5528C15.6162 17.0588 15.0155 16.8586 14.5215 17.1056C14.4998 17.1164 14.4753 17.0968 14.4812 17.0732L15.4116 13.3518Z",
    fill: "#60636B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDsInfo);
export default __webpack_public_path__ + "static/media/icon-ds-info.6ec3227528aa212229de65794faa73b4.svg";
export { ForwardRef as ReactComponent };